import React, { FC, ReactNode } from 'react'
import s from './mawooButton.module.scss'

type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'danger'
  | 'outline'
  | 'secondary-outline'

interface ButtonProps {
  children: ReactNode
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  className?: string
  disabled?: boolean
  variant?: ButtonVariant
}

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  className = '',
  disabled = false,
  variant = 'primary',
}) => {
  // Combine the base class with the variant class
  const buttonClass = `${s.btn} ${s[variant]} ${className}`

  return (
    <button
      type={type}
      onClick={onClick}
      className={buttonClass}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default Button
